import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Preloader from '../../../components/general/Preloader';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Teacher from './Teacher';

const ModalShowCourse = (props) => {
    const token = document.querySelector("[name='csrf-token']").content;
    const [isLoaded, setIsLoaded] = useState(true);
    const [course, setCourse] = useState({});
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },

        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },

        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },

        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    }

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        fetch(`/affiliate/get_course_show/${props.course.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            setCourse(data.register);
            setIsLoaded(false);
        });
    }

    return (
        <React.Fragment>
            <Modal isOpen={props.modal} toggle={props.toggle} className="modal-dialog-centered modal-lg" backdrop={props.backdrop}>
                {!isLoaded ? (
                    <React.Fragment>
                        <div className="col-md-12 mt-3">
                            <h3 className='mb-0 text-primary'>{course.name}</h3>
                        </div>

                        <div className="col-md-12">
                            <hr />
                        </div>

                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6">
                                    <img src={course.image} className="img-fluid"  />
                                </div>

                                <div className="col-md-6">
                                    <p className='text-dark'>{course.description}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <hr />
                        </div>

                        <div className="col-md-12 mt-3 mb-3">
                            <div className="color">
                                <div className="row">
                                    <div className="col-md-4 text-center text-primary">
                                        {course.topics.length} Módulos
                                    </div>

                                    <div className="col-md-4 text-center text-primary">
                                        {course.count_files} Archivos
                                    </div>
                                    
                                    <div className="col-md-4 text-center">
                                        <span className='text-primary'>Calificación del curso</span> <br />
                                        <div className="ratings">
                                            <span style={{ color: "orange" }} className="fa fa-star"></span>
                                            <span style={{ color: "orange" }} className="fa fa-star"></span>
                                            <span style={{ color: "orange" }} className="fa fa-star"></span>
                                            <span style={{ color: "orange" }} className="fa fa-star"></span>
                                            <span style={{ color: "orange" }} className="fa fa-star"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                                                                                                                                                                                                                                                  

                        <div className="col-md-12">
                            <hr />
                        </div>

                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12 mb-2">
                                    <h4 className='text-primary'>Beneficios: </h4>
                                </div>

                                <div className="col-md-12">
                                    <ul style={{ listStyle: "circle" }}>
                                        {course.benefits.map((benefit, index) => (
                                            <li className='text-dark' key={index}> <b>- {benefit}</b></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <hr />
                        </div>

                        <div className="col-md-12 mb-5 mt-5">
                            <Carousel 
                                arrows={true}
                                draggable
                                responsive={responsive}
                            >
                                {course.teachers.map(teacher => (
                                    <Teacher
                                        key={teacher.id}
                                        teacher={teacher}
                                    />
                                ))}
                            </Carousel>
                        </div>
                        
                        {course.topics.length >= 1 && (
                            <React.Fragment>
                                <div className="col-md-12">
                                    <hr />
                                </div>

                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-12 mb-2">
                                            <h4 className='text-primary'>Contenido temático: </h4>
                                        </div>

                                        <div className="col-md-12">
                                            {course.topics.map(topic => (
                                                <div className="card mb-2" key={topic.id}>
                                                    <div className="card-body p-2">
                                                        <h5>{topic.name}</h5>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}

                    </React.Fragment>
                ) : (
                    <div className="text-center">
                        <Preloader/>
                    </div>
                )}
                <ModalFooter>
                    <button className="btn btn-primary" onClick={() => props.toggle()}>Cerrar</button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}


export default ModalShowCourse;

// Curso de Salud Mental $69,000
// orden alfabetico las ciudades del select de ciudades a la hora de crear un usuario